// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2hfte","buttons":"SendReceipts_buttons__kU8sx","email":"SendReceipts_email__2UMdA","bookApptTitle":"SendReceipts_bookApptTitle__1dG0z"};